// Libs
import React, { useEffect, useState } from 'react';
// Own Libs
import * as ui from '@digital/ui';
import { solicitacaoIdState } from '../../atoms';
import { useRecoilState } from 'recoil';
import { AprovacaoSolicitacaoNaoPrevisto, getAprovacoesNaoPrevisto, syncAppAprovador } from '@app/api/naoPrevistos/solicitacao';
import { ETipoAprovacaoSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { Collapse, Icon } from 'antd';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import ModalJustificativa from './ModalJustificativa';
import IntegracaoAprovador from './IntegracaoAprovador';

const { Panel } = Collapse;

const AbaAcompanhamentoAdmin = () => {
    const { match } = ui.useRouter();
    const [id, setId] = useRecoilState(solicitacaoIdState);
    const [validacoes, setValidacoes] = useState<AprovacaoSolicitacaoNaoPrevisto[]>([])
    const [aprovacoes, setAprovacoes] = useState<AprovacaoSolicitacaoNaoPrevisto[]>([])
    // Ids das aprovações que podem ser enviadas agora (sequencial): a anterior já tem data/hora
    // de aprovação preenchida e esta ainda não tem documento nem foi concluída.
    const [idsEnviaveis, setIdsEnviaveis] = useState<string[]>([])

    const getAprovacoes = () => {
        if (id) {
            getAprovacoesNaoPrevisto(id).then((result) => {
                if (result && result.length > 0) {
                    setIdsEnviaveis(result
                        .filter((item, index) =>
                            !item.appAprovadorId &&
                            !item.dataAprovacao &&
                            (index === 0 || !!result[index - 1].dataAprovacao))
                        .map((item) => item.id))

                    setValidacoes(result.filter((item) =>
                    (
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.ValidacaoAdministrador ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.ValidacaoGDGPP ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.ValidacaoGerenciaGFG)
                    ))
                    setAprovacoes(result.filter((item) =>
                    (
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.GerenteGeralAreaSolicitante ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorAreaSolicitante ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.GerenteGeralGP ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorImplantacao ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorEstatutaria ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorSustentabilidade ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorOperacoes ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorFinanceiro ||
                        item.tipoAprovacaoSolicitacaoNaoPrevistoId === ETipoAprovacaoSolicitacaoNaoPrevisto.DiretorPresidente
                    )
                    ))
                }
            })
        }
    }

    // useMemo(() => first, [second])

    useEffect(() => {
        if (id && match.params.section === 'acompanhamentoAdmin') {
            getAprovacoes()
        }
    }, [match.params.section, id])

    const columnsFunc = (exibirIntegracao: boolean = false) => {
        let columns: ui.ColumnProps<AprovacaoSolicitacaoNaoPrevisto>[] = []

        columns.push({
            title: 'Tipo',
            dataIndex: 'tipoAprovacaoSolicitacaoNaoPrevistoNome',
            width: '15%',
            ...mountFormFilterDropDown('tipoAprovacaoSolicitacaoNaoPrevistoNome', 'Pesquisar')
        })

        columns.push({
            title: 'Nome Responsável',
            dataIndex: 'aprovador',
            width: '15%',
            ...mountFormFilterDropDown('aprovador', 'Pesquisar')
        })

        columns.push({
            title: 'Data Hora',
            dataIndex: 'dataAprovacaoFormatada',
            width: '15%',
            ...mountFormFilterDropDown('dataAprovacaoFormatada', 'Pesquisar')
        })

        columns.push({
            title: 'Status',
            dataIndex: 'statusAprovacaoSolicitacaoNaoPrevistoNome',
            width: '15%',
            ...mountFormFilterDropDown('statusAprovacaoSolicitacaoNaoPrevistoNome', 'Pesquisar')
        })

        if (exibirIntegracao) {
            columns.push({
                title: 'Integração Aprovador',
                dataIndex: 'appAprovadorId',
                width: '20%',
                render: (text, record) => {
                    return <IntegracaoAprovador
                        aprovacaoId={record.id}
                        appAprovadorId={record.appAprovadorId}
                        appAprovadorDocumentId={record.appAprovadorDocumentId}
                        isDaVez={idsEnviaveis.includes(record.id)}
                        onSuccess={getAprovacoes} />
                },
            })
        }

        columns.push({
            title: 'Ações',
            dataIndex: 'acoes',
            render: (text, record) => {
                return <ModalJustificativa justificativa={record.justificativa} />
            },
            width: '5%',
        })

        return columns
    }

    const handleAtualizar = () => {
        syncAppAprovador(id).then(() => {
            getAprovacoes()
        })
    }

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="1" header={'Validações'} style={{ border: 0 }}>
                    <ui.Widget actions={[
                        <ui.Button type="primary" onClick={() => handleAtualizar()} key="1">Atualizar</ui.Button>
                    ]}>
                        <ui.Row>
                            <ui.Table
                                columns={columnsFunc()}
                                rowKey="index"
                                dataSource={validacoes}
                                pagination={false} />
                        </ui.Row>
                    </ui.Widget >
                </Panel>
            </Collapse>
            <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />} >
                <Panel key="2" header={'Aprovações'} style={{ border: 0 }}>
                    <ui.Widget actions={[
                        <ui.Button type="primary" onClick={() => handleAtualizar()} key="1">Atualizar</ui.Button>
                    ]}>
                        <ui.Row>
                            <ui.Table
                                columns={columnsFunc(true)}
                                rowKey="index"
                                dataSource={aprovacoes}
                                pagination={false} />
                        </ui.Row>
                    </ui.Widget >
                </Panel>
            </Collapse>
        </>
    )
}

export default AbaAcompanhamentoAdmin